<template>
    <div class="section text-center mt-1" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div class="section" v-else>
        <div class="card">
            <div class="card-header">
                <h5>Field Configuration Test</h5>
            </div>
            <div class="card-body">
                <Form v-if="fields && fields.length > 0" @submit="handleSubmit" :validation-schema="schema">
                    <div class="form-group basic" v-for="field in enabledFields" :key="field.id">
                        <div class="input-wrapper">
                            <label class="label text-primary" :for="field.column_id">
                                {{ field.label }}
                                <span class="text-danger" v-if="field.required">*</span>
                            </label>
                            
                            <template v-if="field.type === 'Select' && field.column_id === 'wing'">
                                <div class="row">
                                    <div class="col-md-6">
                                        <Field
                                            as="select"
                                            class="form-control custom-select"
                                            :name="field.column_id"
                                            v-model="formData[field.column_id]"
                                            :required="field.required"
                                        >
                                            <option value="">Select {{ field.label }}</option>
                                            <option 
                                                v-for="option in getFieldOptions(field)"
                                                :key="option.value"
                                                :value="option.value"
                                            >
                                                {{ option.label }}
                                            </option>
                                        </Field>
                                    </div>
                                    <div class="col-md-6" v-if="formData[field.column_id]">
                                        <Field
                                            type="text"
                                            class="form-control"
                                            :name="field.column_id + '_text'"
                                            v-model="formData[field.column_id + '_text']"
                                            :placeholder="'Enter details for ' + getWingLabel(formData[field.column_id])"
                                        />
                                    </div>
                                </div>
                            </template>

                            <template v-else-if="field.type === 'Select'">
                                <Field
                                    as="select"
                                    class="form-control custom-select"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :required="field.required"
                                >
                                    <option value="">Select {{ field.label }}</option>
                                    <option 
                                        v-for="option in getFieldOptions(field)"
                                        :key="option.value"
                                        :value="option.value"
                                    >
                                        {{ option.label }}
                                    </option>
                                </Field>
                            </template>

                            <template v-else-if="field.type === 'Radio'">
                                <div class="form-check-inline">
                                    <div v-for="option in getFieldOptions(field)"
                                        :key="option.value" 
                                        class="form-check form-check-inline">
                                        <Field
                                            type="radio"
                                            class="form-check-input"
                                            :value="option.value"
                                            :name="field.column_id"
                                            :id="field.column_id + '_' + option.value"
                                            v-model="formData[field.column_id]"
                                        />
                                        <label class="form-check-label" 
                                            :for="field.column_id + '_' + option.value">
                                            {{ option.label }}
                                        </label>
                                    </div>
                                </div>
                            </template>

                            <template v-else-if="field.type === 'datetime-local'">
                                <Field
                                    type="datetime-local"
                                    class="form-control"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :required="field.required"
                                />
                            </template>

                            <template v-else-if="field.type === 'textarea'">
                                <Field
                                    as="textarea"
                                    class="form-control"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :placeholder="field.label"
                                    :required="field.required"
                                    rows="3"
                                />
                            </template>

                            <template v-else-if="field.type === 'Number' && (field.column_id === 'mobile2' || field.column_id === 'whatsapp' || field.column_id === 'mobile_new')">
                                <div class="input-group">
                                    <Field 
                                        as="select" 
                                        class="form-control custom-select" 
                                        style="width:30% !important; max-width: 120px; margin-right: 8px; border-radius: 6px;"
                                        v-model="formData[field.column_id + '_country_code']"
                                        :name="field.column_id + '_country_code'"
                                    >
                                        <option v-for="item in country_code_list" :value="item.item_value" :key="item.item_value">
                                            {{ item.name }}
                                        </option>
                                    </Field>
                                    <Field
                                        type="number"
                                        class="form-control"
                                        style="width:calc(70% - 8px) !important; border-radius: 6px;"
                                        :name="field.column_id"
                                        v-model="formData[field.column_id]"
                                        :placeholder="field.label"
                                        :required="field.required"
                                        maxlength="10"
                                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                    />
                                </div>
                            </template>

                            <template v-else-if="field.type === 'Number'">
                                <Field
                                    type="number"
                                    class="form-control"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :placeholder="field.label"
                                    :required="field.required"
                                />
                            </template>

                            <template v-else>
                                <Field
                                    type="text"
                                    class="form-control"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :placeholder="field.label"
                                    :required="field.required"
                                />
                            </template>

                            <ErrorMessage :name="field.column_id" class="error-feedback" />
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary btn-block">Save</button>
                </Form>
            </div>
        </div>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import { defineRule } from 'vee-validate';
import UserService from "../../services/user.service";
import AlertModel from "./../layouts/AlertModel.vue";

// Define validation rules
defineRule('required', value => {
    if (!value || !value.length) {
        return 'This field is required';
    }
    return true;
});

defineRule('email', value => {
    if (!value) return true;
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!emailPattern.test(value)) {
        return 'This field must be a valid email';
    }
    return true;
});

defineRule('length', (value, [limit]) => {
    if (!value) return true;
    if (value.length !== limit) {
        return `This field must be exactly ${limit} characters`;
    }
    return true;
});

defineRule('regex', (value, [pattern]) => {
    if (!value) return true;
    if (!new RegExp(pattern).test(value)) {
        return 'This field format is invalid';
    }
    return true;
});

export default {
    name: "CallFollowUpTestFields",
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel
    },
    data() {
        return {
            loading: true,
            fields: [],
            formData: {},
            alert_type: "",
            alert_message: "",
            district_list: [],
            status_list: [],
            country_code_list: []
        };
    },
    computed: {
        enabledFields() {
            return this.fields
                .filter(field => field.enabled)
                .sort((a, b) => (a.order || 0) - (b.order || 0));
        },
        schema() {
            const validationRules = {};
            this.fields.forEach(field => {
                if (field.enabled) {
                    const rules = {};
                    
                    if (field.required) {
                        rules.required = 'This field is required';
                    }

                    switch (field.column_id) {
                        case 'mobile2':
                        case 'whatsapp':
                        case 'mobile_new':
                            rules.length = {
                                value: 10,
                                message: 'Mobile number must be 10 digits'
                            };
                            rules.regex = {
                                pattern: /^[0-9]{10}$/,
                                message: 'Please enter a valid mobile number'
                            };
                            break;
                        case 'email':
                            rules.email = 'Please enter a valid email address';
                            break;
                    }

                    validationRules[field.column_id] = rules;
                }
            });
            return validationRules;
        }
    },
    mounted() {
        if (!this.$route.params.id) {
            this.loading = false;
            this.alert_type = 'Error';
            this.alert_message = 'Campaign ID is required';
            this.$refs.alert_model.openModel();
            return;
        }
        this.initializeData();
    },
    methods: {
        async initializeData() {
            try {
                await Promise.all([
                    this.getComboboxValues('CALL_CAMPAIGN_STATUS'),
                    this.getComboboxValues('COUNTRY_CODE'),
                    this.getCampign()
                ]);
            } catch (error) {
                this.alert_type = 'Error';
                this.alert_message = 'Failed to initialize data';
                this.$refs.alert_model.openModel();
            } finally {
                this.loading = false;
            }
        },
        getComboboxValues(code) {
            return new Promise((resolve, reject) => {
                UserService.getCombobox({ code }).then(
                    (response) => {
                        if (code === "CALL_CAMPAIGN_STATUS") {
                            this.status_list = response.data.data.list.options;
                        }
                        if (code === "COUNTRY_CODE") {
                            this.country_code_list = response.data.data.list.options;
                        }
                        resolve();
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },
        getCampign() {
            return new Promise((resolve, reject) => {
                const data = {
                    id: this.$route.params.id
                };
                
                UserService.authPostRequest('v2/get-call-campign', data).then(
                    (response) => {
                        if (response.data.status === 'success' && response.data.data) {
                            // Get campaign data from 'campign' (note the spelling)
                            const campaignData = response.data.data.campign;
                            
                            if (campaignData && campaignData.fields) {
                                // Map fields with their types from API
                                this.fields = campaignData.fields.map(field => {
                                    // Convert API type to component type
                                    let fieldType;
                                    if (field.type) {
                                        switch(field.type.toUpperCase()) {
                                            case 'RADIO':
                                                fieldType = 'Radio';
                                                break;
                                            case 'SELECT':
                                                fieldType = 'Select';
                                                break;
                                            case 'NUMBER':
                                                fieldType = 'Number';
                                                break;
                                            case 'TEXTAREA':
                                                fieldType = 'textarea';
                                                break;
                                            case 'DATETIME':
                                                fieldType = 'datetime-local';
                                                break;
                                            default:
                                                fieldType = 'text';
                                        }
                                    } else {
                                        // Fallback to column-based type determination
                                        fieldType = this.determineFieldType(field.column_id);
                                    }
                                    
                                    return {
                                        ...field,
                                        type: fieldType
                                    };
                                });
                                
                                // Initialize formData
                                this.fields.forEach(field => {
                                    this.formData[field.column_id] = '';
                                    if (field.column_id === 'wing') {
                                        this.formData[field.column_id + '_text'] = '';
                                    }
                                    // Initialize country code for mobile fields
                                    if (field.type === 'Number' && 
                                        (field.column_id === 'mobile2' || 
                                         field.column_id === 'whatsapp' || 
                                         field.column_id === 'mobile_new')) {
                                        this.formData[field.column_id + '_country_code'] = '+91'; // Default to India
                                    }
                                });
                            }

                            // Get district list
                            if (response.data.data.district) {
                                this.district_list = response.data.data.district;
                            }

                            resolve();
                        } else {
                            reject(new Error(response.data.message || 'Failed to load campaign data'));
                        }
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },
        determineFieldType(columnId) {
            switch (columnId) {
                case 'gender':
                case 'district_id':
                case 'zone_id':
                case 'unit_id':
                case 'calling_status':
                    return 'Select';
                case 'pr_listener':
                case 'pr_finance':
                case 'mobile_changed':
                case 'registration_status':
                case 'self_confirmation_status':
                case 'will_come':
                case 'food_needed':
                case 'visited_status':
                    return 'Radio';
                case 'mobile2':
                case 'whatsapp':
                case 'mobile_new':
                    return 'Number';
                case 'will_arrive_at':
                    return 'datetime-local';
                case 'pr_opinion':
                case 'pr_help_needed':
                    return 'textarea';
                default:
                    return 'text';
            }
        },
        getFieldOptions(field) {
            switch (field.column_id) {
                case 'gender':
                    return [
                        { value: 'M', label: 'Male' },
                        { value: 'F', label: 'Female' }
                    ];
                case 'district_id':
                    return this.district_list.map(district => ({
                        value: district.id,
                        label: district.name
                    }));
                case 'calling_status':
                    return this.status_list.map(status => ({
                        value: status.id,
                        label: status.name
                    }));
                case 'wing':
                    return [
                        { value: '1', label: 'ORG' },
                        { value: '2', label: 'Youth' },
                        { value: '3', label: 'Student' },
                        { value: '4', label: 'Womens' },
                        { value: '5', label: 'Balavedi' },
                        { value: '6', label: 'Girls' }
                    ];
                case 'pr_listener':
                case 'pr_finance':
                case 'mobile_changed':
                case 'registration_status':
                case 'self_confirmation_status':
                case 'will_come':
                case 'food_needed':
                case 'visited_status':
                    return [
                        { value: 'Y', label: 'Yes' },
                        { value: 'N', label: 'No' }
                    ];
                default:
                    return [];
            }
        },
        handleSubmit(values) {
            // Format phone numbers with country code
            const formattedValues = { ...values };
            
            // Add country code to mobile numbers
            const mobileFields = ['mobile2', 'whatsapp', 'mobile_new'];
            mobileFields.forEach(field => {
                if (formattedValues[field] && formattedValues[field].toString().length > 0) {
                    const countryCode = this.formData[field + '_country_code'] || '+91';
                    const number = formattedValues[field].toString();
                    
                    // Remove any existing country code if present
                    const cleanNumber = number.replace(/^\+\d+/, '');
                    
                    // Add the selected country code
                    formattedValues[field] = countryCode + cleanNumber;
                }
            });
            
            this.alert_type = 'Success';
            this.alert_message = 'Form submitted successfully';
            this.$refs.alert_model.openModel();
        },
        getWingLabel(wing) {
            switch(wing) {
                case '1': return 'ORG';
                case '2': return 'Youth';
                case '3': return 'Student';
                case '4': return 'Womens';
                case '5': return 'Balavedi';
                case '6': return 'Girls';
                default: return `Wing ${wing}`;
            }
        }
    }
};
</script>

<style scoped>
.error-feedback {
    color: red;
    font-size: 0.875rem;
    margin-top: 0.25rem;
}
</style> 